const API_KEY = '8162952F-3F24-43E0-A20A-6C0E4C7E6B1F';
export default API_KEY;
